import { render, staticRenderFns } from "./DetalleTimbreIlimitados.vue?vue&type=template&id=37e9972c&scoped=true"
import script from "./DetalleTimbreIlimitados.vue?vue&type=script&lang=js"
export * from "./DetalleTimbreIlimitados.vue?vue&type=script&lang=js"
import style0 from "./DetalleTimbreIlimitados.vue?vue&type=style&index=0&id=37e9972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9972c",
  null
  
)

export default component.exports